export const defaultUrl = 'https://backend.develop.bim.flykube.agifly.cloud/api/v1/';
export const assetsUrl = 'https://backend.develop.bim.flykube.agifly.cloud';

export const getAllProjects = `${defaultUrl}web/project`;
export const sendContactApi = `${defaultUrl}web/project/contact`;
